import * as R from 'ramda';
import { useFormik } from 'formik';
import React, { useMemo } from 'react';
// components
import { FormFooter } from '../../../../components/form-footer';
import { FormSectionHeader } from '../../../../components/form-section-header';
// forms
import { Fieldset2 } from '../../../../forms';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// feature fleet/profile
import {
  truckFieldsGroups,
  truckDefaultFields,
  trailerFieldsGroups,
  trailerDefaultFields,
  truckValidationSchema,
  trailerValidationSchema,
} from './settings';
//////////////////////////////////////////////////

const useFormSettings = (props) => {
  const { type, submitAction, initialValues, isReadOnlyMode } = props;

  const isTrailer = R.equals(type, 'trailer');

  const defaultFields = G.ifElse(isTrailer, trailerDefaultFields, truckDefaultFields);

  const onSubmit = (values, { setSubmitting }) => {
    const failCallback = () => setSubmitting(false);
    const successCallback = () => setSubmitting(false);

    submitAction(G.mapObjectEmptyStringFieldsToNull(values), { failCallback, successCallback });
  };

  const validationSchema = G.ifElse(isTrailer, trailerValidationSchema, truckValidationSchema);

  const formik = useFormik({
    onSubmit,
    validationSchema,
    initialValues: R.mergeDeepRight(defaultFields, R.filter(R.isNotNil, initialValues)),
  });

  const temperatureControl = R.path(['values', GC.FIELD_TEMPERATURE_CONTROL], formik);

  const fieldsGroups = useMemo(() => {
    let groups = truckFieldsGroups;

    if (isTrailer) {
      groups = G.ifElse(temperatureControl, trailerFieldsGroups, R.take(1, trailerFieldsGroups));
    }

    if (isReadOnlyMode) {
      groups = R.map(({ fieldSettings, ...group }) => ({
        ...group,
        fieldSettings: R.map(R.assoc('disabled', true), fieldSettings),
      }), groups);
    }

    return groups;
  }, [isTrailer, temperatureControl]);

  return { ...formik, fieldsGroups };
};

const SpecificationForm = (props) => {
  const { formWidth = 1030, isReadOnlyMode, optionsForSelect } = props;

  const formSettings = useFormSettings(props);

  const { fieldsGroups, isSubmitting, handleSubmit } = formSettings;

  const submitBtnStyles = G.ifElse(isReadOnlyMode, { display: 'none' }, {});

  return (
    <form onSubmit={handleSubmit}>
      {
        fieldsGroups.map(({ fieldSettings, formSectionTitle }, index) => (
          <FormSectionHeader
            key={index}
            expanded={true}
            title={formSectionTitle}
          >
            <Fieldset2
              {...optionsForSelect}
              {...G.getFormikPropsToFieldset(formSettings)}
              key={index}
              fields={fieldSettings}
              fieldsWrapperStyles={{
                mt: 25,
                px: 15,
                flexWrap: 'wrap',
                width: formWidth,
              }}
            />
          </FormSectionHeader>
        ))
      }
      <FormFooter
        submitDisabled={isSubmitting}
        submitBtnStyles={submitBtnStyles}
        boxStyles={{ px: 15, width: formWidth }}
      />
    </form>
  );
};

export default SpecificationForm;
